import React from "react";
import styled from "styled-components";
import "./KpopbdayPhonePage.css";

export const theme = {
  colors: {
    // background: "#000000",
    text: "#FFFFFF",
    textSecondary: "#808080",
    primary: "#404040",
  },
  breakpoints: {
    mobile: "320px",
    tablet: "768px",
    desktop: "1024px",
  },
};

const IphonePage = () => {
  return (
    <div style={{ width: "100%", margin: "auto" }}>
      <Container>
        <ContainerSpacer />
        <ContentSection>
          <Title
            onClick={() =>
              window.open("https://kpopbday.danials.space/", "_blank")
            }
            style={{ cursor: "pointer" }}
          >
            Kpopbday
          </Title>
          <Description>
            Discover and track your favorite K‑Pop idols with a dynamic birthday
            calendar that shows detailed profiles and upcoming celebrations all
            year round.
          </Description>
          <Feature>
            <a
              href="https://kpopbday.danials.space/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              🚀 Try Kpopbday
            </a>
          </Feature>
          <FeatureList>
            <Feature>✦ Monthly and daily birthday views</Feature>
            <Feature>✦ Track upcoming birthdays at a glance</Feature>
            <Feature>✦ Aesthetic light theme</Feature>
            <Feature>✦ Search by group and idol name</Feature>
          </FeatureList>
        </ContentSection>
        <ImageSection>
          <div className="phone-mockup">
            <iframe
              src="home-screen-kpopbday-phone.html"
              title="Kpopbday Web App"
              className="webapp-iframe"
            ></iframe>
          </div>
        </ImageSection>
      </Container>
    </div>
  );
};

const ContainerSpacer = styled.div`
  flex: 1.5;
  @media (max-width: 1280px) {
    display: none;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 90%;
  background-color: ${theme.colors.background};
  padding: 4rem 2rem;
  justify-content: space-between;
  @media (max-width: 768px) {
    padding: 2rem 1rem 8rem 1rem;
  }
`;

const ContentSection = styled.div`
  flex: 2.5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;

  @media (max-width: 1280px) {
    padding: 0;
  }
`;

const Title = styled.h1`
  font-size: 3rem;
  color: ${theme.colors.text};
  cursor: pointer;

  @media (max-width: 1280px) {
    font-size: 3rem;
  }
`;

const Description = styled.p`
  font-size: 1.2rem;
  color: ${theme.colors.textSecondary};
  max-width: 37.5rem;
  line-height: 1.6;
`;

const ImageSection = styled.div`
  flex: 4.5;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1280px) {
    display: none;
  }
`;

const FeatureList = styled.div`
  list-style: none;
  padding: 0;
  margin: 2rem 0;
  color: ${theme.colors.text};
  display: flex;
  flex-direction: column;
`;

const Feature = styled.div`
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
`;

export default IphonePage;
